/**
 * 이동 다이얼로그 — 직전에 고른 대상이 목록에 있으면 그 id를 기본값으로 쓴다.
 */

export function pickRememberedMoveTargetId(items, rememberedId) {
  if (rememberedId == null || rememberedId === '' || !Array.isArray(items)) {
    return null;
  }
  const hit = items.find(item => item != null && String(item.id) === String(rememberedId));
  return hit ? hit.id : null;
}
